module.exports = __webpack_public_path__ + "static/media/sdg_icon_13.baa93954.png";